export default "__VITE_ASSET__31301fdd__"